module.exports = __webpack_public_path__ + "img/hoshino_main2.81ed1db4.jpg";